import backroomModuleDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const backroomModuleReducer = backroomModuleDispatcher(initialState, {
  [backroomModuleDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [backroomModuleDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [backroomModuleDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default backroomModuleReducer;
